import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.5 16.583a1.3 1.3 0 0 1-.437-.072 1 1 0 0 1-.38-.246l-5.362-5.326A1.1 1.1 0 0 1 5 10.13q0-.492.32-.81A1.1 1.1 0 0 1 6.138 9q.495 0 .816.318l4.547 4.516 4.547-4.516A1.1 1.1 0 0 1 16.863 9q.496 0 .816.318.321.32.321.81 0 .493-.32.811l-5.364 5.326a1 1 0 0 1-.379.246 1.3 1.3 0 0 1-.437.072" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }